import {font_f_title, font_s_lg, colors} from '@xpertdox_js/xdstyle';

export default {
  title: {
    ...font_f_title,
    ...font_s_lg,
    fontSize: '1.5rem',
    marginBottom: 3
  },
  saveBtnContainer: {
    marginTop: '8px',
    position: 'absolute',
    top: 5,
    right: 5,
  },
  ctmsBox: {
    padding: 8,
    fontSize: '1.28rem'
  },
  ctmsP: {
    margin: 5
  },
  icon: {
    height: 12,
    width: 12,
    cursor: 'pointer',
    fill: colors.xdHighlight
  }
}
